import { cn } from "@omni/utils/styles";

import { Compare } from "@/components/Product/ECommerce/components/compare/compare.component";

type ComparisonProps = {
    sku: string;
    isAdditionalService: boolean;
    isBoxArticle: boolean;
    className?: string;
};

const Comparison = ({
    sku,
    isAdditionalService,
    isBoxArticle,
    className
}: ComparisonProps) => {
    return (
        <Compare
            className={cn(className)}
            sku={sku}
            isAdditionalService={isAdditionalService}
            isBoxArticle={isBoxArticle}
        />
    );
};

export { Comparison };
